(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/draw-picker-top-buttons.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/draw-picker-top-buttons.js');

'use strict';

const memoFetchSpan = svs.lyckoplatsen.utils.page_result.memoFetchSpan;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  selectedSpanResultsAtom = _svs$lyckoplatsen$com.selectedSpanResultsAtom,
  shouldShowIntervalAtom = _svs$lyckoplatsen$com.shouldShowIntervalAtom;
const _jotai = jotai,
  useSetAtom = _jotai.useSetAtom;
const Button = svs.ui.ReactButton;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const RESULT_INTERVALS = svs.lyckoplatsen.components.shared_constants.CONSTANTS.RESULT_INTERVALS;
const INTERVAL_PATHS = {
  30: RESULT_INTERVALS.THIRTY_DAYS,
  183: RESULT_INTERVALS.SIX_MONTHS,
  365: RESULT_INTERVALS.ONE_YEAR
};
const DrawPickerTopButtons = _ref => {
  let handleClose = _ref.handleClose;
  const setSpanResults = useSetAtom(selectedSpanResultsAtom);
  const setShouldShowInterval = useSetAtom(shouldShowIntervalAtom);
  const history = useHistory();
  const setResultsSpan = async days => {
    const spanResults = await memoFetchSpan(days);
    setSpanResults(spanResults);
    setShouldShowInterval(true);
    history.push("/resultat/".concat(INTERVAL_PATHS[days]));
    handleClose === null || handleClose === void 0 || handleClose();
  };
  return React.createElement("div", {
    className: "lp-draw-picker-top-buttons"
  }, React.createElement("div", {
    className: "buttons-wrapper"
  }, React.createElement(Button, {
    className: "lp-blue-dark",
    onClick: () => setResultsSpan(30)
  }, "30 dagar"), React.createElement(Button, {
    className: "lp-blue-dark",
    onClick: () => setResultsSpan(183)
  }, "6 m\xE5nader"), React.createElement(Button, {
    className: "lp-blue-dark",
    onClick: () => setResultsSpan(365)
  }, "1 \xE5r")));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  DrawPickerTopButtons
});

 })(window);